import script from "./Reviews.vue?vue&type=script&setup=true&lang=js"
export * from "./Reviews.vue?vue&type=script&setup=true&lang=js"

import "./Reviews.vue?vue&type=style&index=0&id=38fb4cd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38fb4cd5"]])

export default __exports__